import React from 'react';
import ProtectedRoute from './protected.js';
import DepartmentPage from '../pages/department-management.js/index.js';
import ViewDepartmentPage from '../pages/department-management.js/view-departments.js';

export const DepartmentsRoutes = [
  <ProtectedRoute exact path='/department' component={DepartmentPage} />,
  <ProtectedRoute exact path='/department/view/:id' component={ViewDepartmentPage} />,
];